package component.product

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import feature.productCategory.model.ProductCategory

@Composable
fun ProductCategoryCard(
    category: ProductCategory,
    onClick: (category: ProductCategory) -> Unit
) {
    Box(
        modifier = Modifier
            .width(130.dp)
            .height(120.dp)
            .background(Color.White, shape = RoundedCornerShape(10.dp))
            .clip(RoundedCornerShape(10.dp))
            .padding(8.dp)
            .clickable {
                onClick(category)
            },
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(start = 15.dp, end = 15.dp)
        ) {

//            AsyncImageView(
//                painter = painterResource(id = R.drawable.flash_icon),
//                contentDescription = "Flash Deal",
//                modifier = Modifier
//                    .background(
//                        ThemeColor.shared().PrimaryLightColor,
//                        shape = RoundedCornerShape(10.dp)
//                    )
//                    .size(50.dp)
//                    .clip(RoundedCornerShape(10.dp))
//                    .padding(10.dp)
//                    .align(Alignment.CenterHorizontally)
//            )
            Text(text = category.Name!!, fontSize = 14.sp, textAlign = TextAlign.Center)
        }
    }


}